import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { SignupService } from './signup.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class StepService {
    
    private currentStepSubject = new BehaviorSubject<number>(0);
    currentStep$ = this.currentStepSubject.asObservable();

    private businessInfoSubject = new BehaviorSubject<any>({});
    businessInfo$ = this.businessInfoSubject.asObservable();

    private personalInfoSubject = new BehaviorSubject<any>({});
    personalInfo$ = this.personalInfoSubject.asObservable();

    private personalInfoSavedSubject = new BehaviorSubject<boolean>(false);
    personalInfoSaved$ = this.personalInfoSavedSubject.asObservable();

    private businessInfoSavedSubject = new BehaviorSubject<boolean>(false);
    businessInfoSaved$ = this.businessInfoSavedSubject.asObservable();

    private accountVerifiedSubject = new BehaviorSubject<boolean>(false);
    accountVerified$ = this.accountVerifiedSubject.asObservable();

    private onlineWebsiteInfoSubject = new BehaviorSubject<any>({});
    onlineWebsiteInfo$ = this.onlineWebsiteInfoSubject.asObservable();

    private onlineWebsiteConfigurationSubject = new BehaviorSubject<boolean>(
        false
    );
    onlieWebsiteConfigured$ =
        this.onlineWebsiteConfigurationSubject.asObservable();

    private otpTimerCountSubject = new BehaviorSubject<number>(0);
    otpTimerCount$ = this.otpTimerCountSubject.asObservable();

    private businessAddressInfoSubject = new BehaviorSubject<any>({});
    businessAddress$ = this.businessAddressInfoSubject.asObservable();

    private useBusinessAddressSubject = new BehaviorSubject<boolean>(true);
    userBusinessAddressInfo$ = this.useBusinessAddressSubject.asObservable();

    private userSelectedPlanSubject = new BehaviorSubject<any>({});
    userSelectedPlanInfoSaved$ = this.userSelectedPlanSubject.asObservable();

    private userSelectedLocationSubject = new BehaviorSubject<any>({});
    userSelectedLocationInfoSaved$ =
        this.userSelectedLocationSubject.asObservable();

    private userSelectedRegisterSubject = new BehaviorSubject<any>({});
    userSelectedRegisterSaved$ =
        this.userSelectedRegisterSubject.asObservable();

    private billingIntervalSubject = new BehaviorSubject<string>('monthly');
    billingIntervalInfo$ = this.billingIntervalSubject.asObservable();

    private userSelectedHardwaresSubject = new BehaviorSubject<any[]>([]);
    userSelectedHardwaresSaved$ =
        this.userSelectedHardwaresSubject.asObservable();

    private subscroptionPlansListSubject = new BehaviorSubject<any[]>([]);
    subscroptionPlansListSaved$ =
        this.subscroptionPlansListSubject.asObservable();

    private userShippingAddressSubject = new BehaviorSubject<any>({});
    userShippingAddressSaved$ = this.userShippingAddressSubject.asObservable();

    private planUsingLincSellWebsiteSubject = new BehaviorSubject<number>(1);
    planUsingLincSellWebsiteSaved$ =
        this.planUsingLincSellWebsiteSubject.asObservable();

    private isBusinessPlanSelectedUsingLincSellWebsiteSubject =
        new BehaviorSubject<boolean>(false);
    isBusinessPlanSelectedUsingLincSellWebsiteInfo$ =
        this.isBusinessPlanSelectedUsingLincSellWebsiteSubject.asObservable();

    private grandTotalSubject = new BehaviorSubject<number>(0.0);
    grandTotalSaved$ = this.grandTotalSubject.asObservable();

    private inProgress = false;

    private optSendSubject = new BehaviorSubject<boolean>(false);
    otpSendInfo$ = this.optSendSubject.asObservable();

    private isBusinessAddressSavedSubject = new BehaviorSubject<boolean>(false);
    isBusinessAddressSavedInfo$ =
        this.isBusinessAddressSavedSubject.asObservable();

    private linkCouponCodeSubject = new BehaviorSubject<string | null>(null);
    linkCouponCode$ = this.linkCouponCodeSubject.asObservable();

    private allowUnloadOnce = false;

    constructor(public _signup: SignupService,) {
        // Check sessionStorage for 'active-step'
        const storedStep = sessionStorage.getItem('active-step');
        const initialStep = storedStep !== null ? parseInt(storedStep, 10) : 0;
        this.currentStepSubject.next(initialStep);

        // Check sessionStorage for 'business-Info'
        const storedBusinessInfo = sessionStorage.getItem('business-Info');
        if (storedBusinessInfo !== null) {
            try {
                const parsedBusinessInfo = JSON.parse(storedBusinessInfo);
                this.businessInfoSubject.next(parsedBusinessInfo);
                this.businessInfoSavedSubject.next(true); // Set to true if business info is found
            } catch (error) {
                console.error(
                    'Error parsing business info from sessionStorage:',
                    error
                );
            }
        }

        const storedWebsiteInfo = sessionStorage.getItem('website-info');
        if (storedWebsiteInfo !== null) {
            try {
                const parsedBusinessInfo = JSON.parse(storedWebsiteInfo);
                this.onlineWebsiteInfoSubject.next(parsedBusinessInfo);
                this.onlineWebsiteConfigurationSubject.next(true); // Set to true if business info is found
            } catch (error) {
                console.error(
                    'Error parsing business info from sessionStorage:',
                    error
                );
            }
        }

        // Check sessionStorage for 'personal-Info'
        const storedPersonalInfo = sessionStorage.getItem('personal-Info');
        if (storedPersonalInfo !== null) {
            try {
                const parsedPersonalInfo = JSON.parse(storedPersonalInfo);
                this.personalInfoSubject.next(parsedPersonalInfo);
                this.personalInfoSavedSubject.next(true);
            } catch (error) {
                console.error(
                    'Error parsing personal info from sessionStorage:',
                    error
                );
            }
        }

        const storedAccountVerificationInfo =
            sessionStorage.getItem('account-verified');
        if (storedAccountVerificationInfo !== null) {
            try {
                const parsedAccountVerificationInfo = JSON.parse(
                    storedAccountVerificationInfo
                );
                this.accountVerifiedSubject.next(parsedAccountVerificationInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedOTPVerificationCountInfo =
            sessionStorage.getItem('otp-count');
        if (storedOTPVerificationCountInfo !== null) {
            try {
                const parsedOTPInfo = JSON.parse(
                    storedOTPVerificationCountInfo
                );
                this.otpTimerCountSubject.next(parsedOTPInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedBusinessAddress =
            sessionStorage.getItem('business-address');
        if (storedBusinessAddress !== null) {
            try {
                const parsedBusinessAddressInfo = JSON.parse(
                    storedBusinessAddress
                );
                this.businessAddressInfoSubject.next(parsedBusinessAddressInfo);
                this.isBusinessAddressSavedSubject.next(true);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedBusinessAddressInfo = sessionStorage.getItem(
            'use-business-address'
        );
        if (storedBusinessAddressInfo !== null) {
            try {
                const parsedAccountVerificationInfo = JSON.parse(
                    storedBusinessAddressInfo
                );
                this.useBusinessAddressSubject.next(
                    parsedAccountVerificationInfo
                );
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedSelectedPlanUsingLincSellWebsiteInfo =
            sessionStorage.getItem('selected_plan_id');
        if (storedSelectedPlanUsingLincSellWebsiteInfo !== null) {
            try {
                const parsedSelectedPlanInfo = JSON.parse(
                    storedSelectedPlanUsingLincSellWebsiteInfo
                );
                this.planUsingLincSellWebsiteSubject.next(
                    parsedSelectedPlanInfo
                );
                this.isBusinessPlanSelectedUsingLincSellWebsiteSubject.next(
                    true
                ); // Set to true if a plan is found
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedSelectedPlanInfo =
            sessionStorage.getItem('selected-plan-info');
        if (storedSelectedPlanInfo !== null) {
            try {
                const parsedSelectedPlanInfo = JSON.parse(
                    storedSelectedPlanInfo
                );
                this.userSelectedPlanSubject.next(parsedSelectedPlanInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedSelectedLocationInfo = sessionStorage.getItem(
            'stored-selected-location-info'
        );
        if (storedSelectedLocationInfo !== null) {
            try {
                const parsedSelectedPlanInfo = JSON.parse(
                    storedSelectedLocationInfo
                );
                this.userSelectedLocationSubject.next(parsedSelectedPlanInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedSelectedRegisterInfo = sessionStorage.getItem(
            'stored-selected-register-info'
        );
        if (storedSelectedRegisterInfo !== null) {
            try {
                const parsedSelectedPlanInfo = JSON.parse(
                    storedSelectedRegisterInfo
                );
                this.userSelectedRegisterSubject.next(parsedSelectedPlanInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedBillingInfo = sessionStorage.getItem(
            'billing-interval-info'
        );

        if (storedBillingInfo !== null) {
            try {
                const parsedSelectedPlanInfo = JSON.parse(storedBillingInfo);
                this.billingIntervalSubject.next(parsedSelectedPlanInfo);
            } catch (error) {
                this.billingIntervalSubject.next('yearly');
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedHardwareInfo = sessionStorage.getItem(
            'selected-hardware-info'
        );
        if (storedHardwareInfo !== null) {
            try {
                const parsedSelectedPlanInfo = JSON.parse(storedHardwareInfo);
                this.userSelectedHardwaresSubject.next(parsedSelectedPlanInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedShippingAddressInfo = sessionStorage.getItem(
            'shipping-address-info'
        );
        if (storedShippingAddressInfo !== null) {
            try {
                const parsedSelectedPlanInfo = JSON.parse(
                    storedShippingAddressInfo
                );
                this.userShippingAddressSubject.next(parsedSelectedPlanInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedGrandTotalInfo = sessionStorage.getItem('grandTotal');
        if (storedGrandTotalInfo !== null) {
            try {
                const parsedGrandTotalInfo = JSON.parse(storedGrandTotalInfo);
                this.grandTotalSubject.next(parsedGrandTotalInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        const storedOTPInfo = sessionStorage.getItem('otpSend');
        if (storedOTPInfo !== null) {
            try {
                const parsedOTPInfo = JSON.parse(storedOTPInfo);
                this.optSendSubject.next(parsedOTPInfo);
            } catch (error) {
                console.error(
                    'Error parsing account verification info from sessionStorage:',
                    error
                );
            }
        }

        // ✅ Restore link coupon code (for signup links)
        const storedLinkCoupon = sessionStorage.getItem('url_coupon_code');
        if (storedLinkCoupon !== null) {
            try {
                const parsedCoupon = storedLinkCoupon;
                this.linkCouponCodeSubject.next(parsedCoupon);
            } catch (error) {
                console.error('Error parsing link coupon code from sessionStorage:', error);
            }
        }
    } 

    markBusinessInfoSaved(saved: boolean = true): void {
        this.businessInfoSavedSubject.next(saved);
    }

    setInProgress(value: boolean) {
        this.inProgress = value;
        sessionStorage.setItem('signupInProgress', value ? '1' : '0');
    }

    isPaymentSuccessful(): boolean {
        // Treat explicit flag or any nonzero total as success
        if (sessionStorage.getItem('payment-processing') === '1') return true;
        return this.grandTotalSubject.getValue() > 0 ? true : false;
    }

    isInProgress(): boolean {
        return (
            this.inProgress ||
            sessionStorage.getItem('signupInProgress') === '1'
        );
    }

    clear() {
        this.inProgress = false;
        sessionStorage.removeItem('signupInProgress');
    }

    setStep(step: number) {
        this.currentStepSubject.next(step);
    }

    getCurrentStep(): number {
        return this.currentStepSubject.getValue();
    }

    setBusinessInfo(info: any) {
        this.businessInfoSubject.next(info);
    }

    getIsBusinessInfoSaved() {
        return this.businessInfoSavedSubject.getValue();
    }

    getWebsiteInfo() {
        return this.onlineWebsiteConfigurationSubject.getValue();
    }

    setOnlineWebsiteInfo(info: any) {
        this.onlineWebsiteInfoSubject.next(info);
    }

    setPersonalInfo(info: any) {
        this.personalInfoSubject.next(info);
    }

    getPersonalInfoSaved() {
        return this.personalInfoSavedSubject.getValue();
    }

    setOTPInfoSend(otpSend: boolean) {
        this.optSendSubject.next(otpSend);
    }

    getSelectedPlanId(): any {
        return this.planUsingLincSellWebsiteSubject.getValue();
    }

    getCurrentTimerValue(): number {
        return this.otpTimerCountSubject.getValue();
    }

    getAccountVerifiedStatusValue(): boolean {
        return this.accountVerifiedSubject.getValue();
    }

    setAccountVerified(status: boolean) {
        this.accountVerifiedSubject.next(status);
    }

    // New method: Increment the current step
    nextStep() {
        let current = this.getCurrentStep();
        console.log('Current step:', current);


        this.currentStepSubject.next(current + 1);
        if (this.getCurrentStep() > 1 && !this.getAccountVerifiedStatusValue()) {
            console.log('Condition step:', current);
            if (this.getCurrentStep() > 2) {
                this.currentStepSubject.next(1);
            }

        }
    }

    // New method: Decrement the current step if possible
    movePrevious() {
        const current = this.getCurrentStep();
        if (current > 0) {
            this.currentStepSubject.next(current - 1);
        }
    }

    resetOTPCount() {
        this.otpTimerCountSubject.next(0);
        sessionStorage.setItem('otp-count', JSON.stringify(0));
    }

    setOTPCount(count: number) {
        this.otpTimerCountSubject.next(count);
        sessionStorage.setItem('otp-count', JSON.stringify(count));
    }

    setBillingInterval(interval: string) {
        this.billingIntervalSubject.next(interval);
    }

    setSelectedPlanId(selectedPlanId: number) {
        this.planUsingLincSellWebsiteSubject.next(selectedPlanId);
    }

    setBrowseUsingLincsellWebsite(selected: boolean) {
        this.isBusinessPlanSelectedUsingLincSellWebsiteSubject.next(selected);
    }

    setUserSelectedPlan(plan: any) {
        this.userSelectedPlanSubject.next(plan);
    }

    setBusinessAddress(obj: any) {
        this.businessAddressInfoSubject.next(obj);
        this.isBusinessAddressSavedSubject.next(true);
    }

    setBusinessAddressSaved(status: boolean) {
        this.isBusinessAddressSavedSubject.next(status);
    }

    setHardwareSaved(parsedSelectedPlanInfo: any) {
        this.userSelectedHardwaresSubject.next(parsedSelectedPlanInfo);
    }

    setBillingTotal(total: number) {
        this.grandTotalSubject.next(total);
    }

    getIsBusinessAddressSave(): boolean {
        return this.isBusinessAddressSavedSubject.getValue();
    }

    getBillingIntervalSave(): string {
        return this.billingIntervalSubject.getValue();
    }

    setShippingAddressSameAsBilling(status: boolean) {
        this.useBusinessAddressSubject.next(status);
    }

    setShippingAddress(obj: any) {
        this.userShippingAddressSubject.next(obj);
    }




    setSubscriptionPlansList(plans: any[]): void {
        // You can implement this method to store the plans if needed
        console.log('Plans received:', plans);
    }

    // Fetch from API and update subject
    loadSubscriptionPlans(forceRefresh: boolean = false): void {
        const existingPlans = this.subscroptionPlansListSubject.getValue();
        if (!forceRefresh && existingPlans && existingPlans.length > 0) {
            return;
        }

        if (forceRefresh) {
            this._signup.resetSubscriptionPlansCache();
        }

        this._signup.getSubscriptionPlans(forceRefresh).subscribe((res: any) => {
            if (res.success) {
                this.subscroptionPlansListSubject.next(res.data);
            } else {
                this.subscroptionPlansListSubject.next([]); // fallback
            }
        });
    }

    // Optional: synchronous access
    getCurrentPlansList(): any[] {
        return this.subscroptionPlansListSubject.getValue();
    }

    // ✅ Apply discount to the current selected plan
    applyPlanDiscount(discountedPrice: number, couponCode: string): void {
        const currentPlan = this.userSelectedPlanSubject.getValue();

        if (!currentPlan || !currentPlan.cosmosId) return;

        const updatedPlan = {
            ...currentPlan,
            discountedPrice: discountedPrice,
            discountApplied: true,
            appliedCouponCode: couponCode,
        };

        // Update BehaviorSubject + sessionStorage
        this.userSelectedPlanSubject.next(updatedPlan);
        sessionStorage.setItem('selected-plan-info', JSON.stringify(updatedPlan));

        // Also update total billing
        this.grandTotalSubject.next(discountedPrice);
        sessionStorage.setItem('grandTotal', JSON.stringify(discountedPrice));

        console.log('✅ Discount applied to plan:', updatedPlan);
    }

    // ❌ Remove or reset discount
    removePlanDiscount(): void {
        const currentPlan = this.userSelectedPlanSubject.getValue();

        if (!currentPlan || !currentPlan.cosmosId) return;

        const restoredPrice = this.getBillingIntervalSave() === 'yearly'
            ? currentPlan.yearlyPrice
            : currentPlan.monthlyPrice;

        const updatedPlan = {
            ...currentPlan,
            discountedPrice: 0,
            discountApplied: false,
            appliedCouponCode: null,
        };

        this.userSelectedPlanSubject.next(updatedPlan);
        sessionStorage.setItem('selected-plan-info', JSON.stringify(updatedPlan));

        // Restore total billing
        this.grandTotalSubject.next(restoredPrice);
        sessionStorage.setItem('grandTotal', JSON.stringify(restoredPrice));

        console.log('❌ Discount removed from plan.');
    }

    setLinkCouponCode(code: string) {
        if (!code) return;
        this.linkCouponCodeSubject.next(code);
        sessionStorage.setItem('link-coupon-code', JSON.stringify(code));
    }

    getLinkCouponCode(): string | null {
        const inMemory = this.linkCouponCodeSubject.getValue();
        if (inMemory) return inMemory;
        const fromStorage = sessionStorage.getItem('link-coupon-code');
        return fromStorage ? JSON.parse(fromStorage) : null;
    }

    allowNextUnload(): void {
        this.allowUnloadOnce = true;
    }

    consumeAllowUnload(): boolean {
        const allowed = this.allowUnloadOnce;
        this.allowUnloadOnce = false;
        return allowed;
    }


    validateTrackingId(trackingId: string): boolean {
    // basic validation logic — you can expand this if you integrate backend later
    if (!trackingId || typeof trackingId !== 'string') return false;
    if (trackingId.length < 3 || trackingId.length > 50) return false;
    if (!/^[A-Za-z0-9_-]+$/.test(trackingId)) return false; // only allow safe chars
    return true;
    }

    isValidEmail(email: string) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
}
